<template>
  <AtomsButton :label="$t('login.connection')" :to="localePath({name: 'login', query: { next: $route.path }})" />
</template>